import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import Button from "../../Common/Button";

class DisplayFullDataButton extends PureComponent {
  static propTypes = {
    onDisplayFullData: PropTypes.func.isRequired,
    isFullDataDisplayed: PropTypes.bool
  };

  static defaultProps = {
    isFullDataDisplayed: false
  };

  render() {
    return (
      <Button
        className="full-data-display-button"
        onClick={this.props.onDisplayFullData}
        icon={this.props.isFullDataDisplayed ? "full-data-hide" : "full-data-show"}
      />
    );
  }
}

export default DisplayFullDataButton;



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/DisplayFullDataButton.js